"use client"
import { XMarkIcon } from "@heroicons/react/20/solid"
import Image from "next/image"
import Link from "next/link"
import { useEffect, useState } from "react"

export default function TopBanner() {
  // State to manage the visibility of the banner
  const [isVisible, setIsVisible] = useState(true)

  // Check localStorage to see if the banner was previously dismissed
  useEffect(() => {
    const bannerDismissed = localStorage.getItem("bannerDismissed")
    if (bannerDismissed === "true") {
      setIsVisible(false)
    }
  }, [])

  // Function to handle the dismissal of the banner
  const dismissBanner = () => {
    setIsVisible(false)
    localStorage.setItem("bannerDismissed", "true")
  }

  // If the banner is not visible, return null to not render it
  if (!isVisible) {
    return null
  }

  return (
    <div className="flex items-center gap-x-6 bg-purple px-6 py-2.5 sm:px-3.5 sm:before:flex-1">
      <p className="text-sm/6 text-white">
        GoodShift komt voort uit Stichting Goodplace, CBF-erkend donatieplatform.{" "}
        <Link className="font-bold underline" href="https://cbf.nl/donatieplatform-goodplace-foundation/">
          Lees meer
        </Link>
      </p>
      <Image
        width={35}
        height={35}
        src="/goodshift/img/banners/cbf_logo.png"
        alt="Cbf logo"
        style={{ width: "auto", height: "auto" }}
      />
      <div className="flex flex-1 justify-end">
        <button type="button" className="-m-3 p-3 focus-visible:outline-offset-[-4px]" onClick={dismissBanner}>
          <span className="sr-only">Dismiss</span>
          <XMarkIcon aria-hidden="true" className="size-5 text-white" />
        </button>
      </div>
    </div>
  )
}
